import HttpClient from './HttpClient';

const EstadisticasService = {
  promotor: (params) => {
    const path = 'credit/stats/promotores';
    return HttpClient.get(path, params, true);
  },
  activos: (params) => {
    const path = 'credit/stats/activos';
    return HttpClient.get(path, params, true);
  },
  downloadWallet: (params) => {
    const path = 'credit/download/wallet';
    return HttpClient.get(path, params, true);
  },
  downloadMora: (params) => {
    const path = 'credit/download/mora';
    return HttpClient.get(path, params, true);
  },
  downloadPromotor: (params) => {
    const path = 'credit/download/promotores';
    return HttpClient.get(path, params, true);
  }
};

export default EstadisticasService;
